// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1CR4t","table":"Table_table__jIN-8","btn":"Table_btn__tjiBD"};